module.exports = __webpack_public_path__ + "img/image-11.90975e48.webp";